export default __webpack_public_path__ + "static/media/neighbors-preview.6dc6d6fa.png";